// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: 'local',
  accessManager: {
    host: {
      IL: 'http://localhost:8082',
      TX: 'http://localhost:8082',
      OK: 'http://localhost:8082',
      NM: 'http://localhost:8082',
      MT: 'http://localhost:8082',
      DG: 'http://localhost:8082'
    }
  },
  serviceLayer: {
    host: {
      IL: 'http://localhost:8080',
      TX: 'http://localhost:8080',
      OK: 'http://localhost:8080',
      NM: 'http://localhost:8080',
      MT: 'http://localhost:8080',
      DG: 'http://localhost:8080'
    }
  },
  diesl: {
    host: 'http://localhost:8081'
  },
  memberPortal: {
    host: {
      IL: 'http://localhost:8083',
      TX: 'http://localhost:8083',
      OK: 'http://localhost:8083',
      NM: 'http://localhost:8083',
      MT: 'http://localhost:8083',
      DG: 'http://localhost:8083'
    }
  }
};
